module.exports = __webpack_public_path__ + "assets/img/avatar-male.f6f17b24.png";